<template>
  <div>
    <b-row>
      <b-col md="3">
        <b-form-group
          :label="$t('reporting_channel.protocol_number')"
          label-for="protocol"
        >
          <b-form-input
            id="protocol"
            :value="_.get(requestForm, 'form.protocol_number')"
            readonly
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          :label="$t('reporting_channel.created_at')"
          label-for="created_at"
        >
          <b-form-input
            id="created_at"
            :value="_.get(requestForm, 'form.created_date_formatted')"
            readonly
          />
        </b-form-group>
      </b-col>
      <b-col md="3" class="print:hidden content-center">
        <NavigationOriginPopup :navigationField="navigationField" />
      </b-col>
      <b-col md="3" class="print:hidden content-center">
        <ProtocolQueryHistoryPopup
          :protocol_number="_.get(requestForm, 'form.protocol_number')"
          type="reporting-channel"
        />
      </b-col>
    </b-row>
    <b-row md="12">
      <b-col>
        <b-form-group
          :label="$t('reporting_channel.institution_unity')"
          label-for="institution_unity"
        >
          <span
            id="institution_unity"
            class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line  overflow-y-auto h-full"
            readonly
          >
            {{ _.get(requestForm, 'form.legal_entity_name') }}
          </span>
        </b-form-group>
        <b-form-group
          :label="$t('reporting_channel.form.field05')"
          label-for="field05"
        >
          <span
            id="field05"
            class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto"
            :class="configClassTextField(_.get(requestForm, 'form.area'))"
            readonly
          >
            {{ _.get(requestForm, 'form.area') }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <!--  -->
    <b-card :title="$t('reporting_channel.sub_title')">
      <!-- Person data" -->
      <b-row class="m-0">
        <!-- <b-col lg="12" class="d-flex align-items-center px-2 mt-2">-->
        <b-col
          sm="12"
          md="8"
          lg="8"
          class="px-xl-2 px-2 mx-auto align-items-center"
        >
          <div v-if="isIdentify">
            <b-form-group
              :label="$t('reporting_channel.form.field01_01')"
              label-for="field01_01"
            >
              <span
                id="field01_01"
                class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line  overflow-y-auto"
                :class="
                  configClassTextField(
                    _.get(requestForm, 'form.data.form_data.person.name')
                  )
                "
                readonly
              >
                {{ _.get(requestForm, 'form.data.form_data.person.name') }}
              </span>
            </b-form-group>
            <b-form-group
              :label="$t('reporting_channel.form.field01_02')"
              label-for="field01_02"
            >
              <span
                id="field01_02"
                class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line  overflow-y-auto"
                :class="
                  configClassTextField(
                    _.get(requestForm, 'form.data.form_data.person.document')
                  )
                "
                readonly
              >
                {{ _.get(requestForm, 'form.data.form_data.person.document') }}
              </span>
            </b-form-group>
            <b-form-group
              :label="$t('reporting_channel.form.field01_03')"
              label-for="field01_03"
            >
              <span
                id="field01_03"
                class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line  overflow-y-auto"
                :class="
                  configClassTextField(
                    _.get(requestForm, 'form.data.form_data.person.email')
                  )
                "
                readonly
              >
                {{ _.get(requestForm, 'form.data.form_data.person.email') }}
              </span>
            </b-form-group>
            <b-form-group
              :label="$t('reporting_channel.form.field01_04')"
              label-for="field01_04"
            >
              <span
                id="field01_04"
                class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line  overflow-y-auto"
                :class="
                  configClassTextField(
                    _.get(requestForm, 'form.data.form_data.person.phone')
                  )
                "
                readonly
              >
                {{ _.get(requestForm, 'form.data.form_data.person.phone') }}
              </span>
            </b-form-group>
          </div>
          <b-form-group
            :label="$t('reporting_channel.form.field02')"
            label-for="field02"
          >
            <span
              id="field02"
              class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line  overflow-y-auto"
              :class="configClassTextField(customerRelationship)"
              readonly
            >
              {{ customerRelationship }}
            </span>
          </b-form-group>
          <b-form-group
            :label="$t('reporting_channel.form.field03')"
            label-for="field03"
          >
            <span
              id="field03"
              class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto"
              :class="configClassTextField(typeReporting)"
              readonly
            >
              {{ typeReporting }}
            </span>
          </b-form-group>

          <b-form-group
            :label="$t('reporting_channel.form.field06')"
            label-for="field06"
          >
            <span
              id="field06"
              class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto"
              :class="configClassTextField(knowFact)"
              readonly
            >
              {{ knowFact }}
            </span>
          </b-form-group>

          <b-form-group
            :label="$t('reporting_channel.form.field07')"
            label-for="field07"
          >
            <span
              id="field07"
              class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto"
              :class="
                configClassTextField(
                  _.get(requestForm, 'form.data.form_data.statusOfReport.name')
                )
              "
              readonly
            >
              {{
                _.get(requestForm, 'form.data.form_data.statusOfReport.name')
              }}
            </span>
          </b-form-group>

          <b-form-group
            :label="$t('reporting_channel.form.field08')"
            label-for="field08"
          >
            <span
              id="field08"
              class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto"
              :class="
                configClassTextField(
                  _.get(requestForm, 'form.data.form_data.whatReport')
                )
              "
              readonly
            >
              {{ _.get(requestForm, 'form.data.form_data.whatReport') }}
            </span>
          </b-form-group>

          <b-form-group
            :label="$t('reporting_channel.form.field09')"
            label-for="field09"
          >
            <span
              id="field09"
              class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto"
              :class="
                configClassTextField(
                  _.get(requestForm, 'form.data.form_data.keepsHappening')
                )
              "
              readonly
            >
              {{ _.get(requestForm, 'form.data.form_data.keepsHappening') }}
            </span>
          </b-form-group>

          <b-form-group
            :label="$t('reporting_channel.form.field10')"
            label-for="field10"
          >
            <span
              id="field10"
              class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto"
              :class="
                configClassTextField(
                  _.get(requestForm, 'form.data.form_data.whenAndWho')
                )
              "
              readonly
            >
              {{ _.get(requestForm, 'form.data.form_data.whenAndWho') }}
            </span>
          </b-form-group>

          <b-form-group
            :label="$t('reporting_channel.form.field11')"
            label-for="field11"
          >
            <span
              id="field11"
              class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto"
              :class="
                configClassTextField(
                  _.get(requestForm, 'form.data.form_data.otherPeople')
                )
              "
              readonly
            >
              {{ _.get(requestForm, 'form.data.form_data.otherPeople') }}
            </span>
          </b-form-group>

          <b-form-group
            :label="$t('reporting_channel.form.field12')"
            label-for="field12"
          >
            <span
              id="field12"
              class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto"
              :class="
                configClassTextField(
                  _.get(requestForm, 'form.data.form_data.thereEvidence')
                )
              "
              readonly
            >
              {{ _.get(requestForm, 'form.data.form_data.thereEvidence') }}
            </span>
          </b-form-group>

          <b-form-group
            :label="$t('reporting_channel.form.field13')"
            label-for="field13"
          >
            <span
              id="field13"
              class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto"
              :class="
                configClassTextField(
                  _.get(requestForm, 'form.data.form_data.siteProfile')
                )
              "
              readonly
            >
              {{ _.get(requestForm, 'form.data.form_data.siteProfile') }}
            </span>
          </b-form-group>

          <b-form-group
            :label="$t('reporting_channel.form.field14')"
            label-for="field14"
          >
            <span
              id="field14"
              class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto"
              :class="
                configClassTextField(
                  _.get(requestForm, 'form.data.form_data.whyReporting')
                )
              "
              readonly
            >
              {{ _.get(requestForm, 'form.data.form_data.whyReporting') }}
            </span>
          </b-form-group>

          <b-form-group
            :label="$t('reporting_channel.form.field15')"
            label-for="field15"
          >
            <span
              id="field15"
              class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto"
              :class="
                configClassTextField(
                  _.get(requestForm, 'form.data.form_data.howInvestigate')
                )
              "
              readonly
            >
              {{ _.get(requestForm, 'form.data.form_data.howInvestigate') }}
            </span>
          </b-form-group>

          <b-form-group
            :label="$t('reporting_channel.form.field16')"
            label-for="field16"
          >
            <span
              id="field16"
              class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto"
              :class="
                configClassTextField(
                  _.get(requestForm, 'form.data.form_data.employeesAware')
                )
              "
              readonly
            >
              {{
                _.get(requestForm, 'form.data.form_data.employeesAware')
                  ? $t('yes')
                  : $t('no')
              }}
            </span>
          </b-form-group>

          <b-form-group
            :label="$t('reporting_channel.form.field17')"
            label-for="field17"
          >
            <span
              id="field17"
              class="form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto"
              :class="
                configClassTextField(
                  _.get(requestForm, 'form.data.form_data.financialValue')
                )
              "
              readonly
            >
              {{ _.get(requestForm, 'form.data.form_data.financialValue') }}
            </span>
          </b-form-group>

          <media-list
            :medias="files"
            :show-delete="false"
            :action-on-click="true"
          />
        </b-col>
        <!-- </b-col> -->
      </b-row>
    </b-card>
    <!-- End Person data-->

    <!-- -->
    <b-row class="m-0">
      <b-col lg="12">
        <h5 class="mt-2 mb-0">
          {{ title || $t('reporting_channel.handling') }}
        </h5>
        <vs-divider></vs-divider>
      </b-col>
    </b-row>
    <b-row class="m-0">
      <b-col lg="4">
        <b-form-group
          :label="$t('reporting_channel.severity_level')"
          label-for="severity_level"
        >
          <b-form-input
            id="severity_level"
            :value="severityLevelDisplay"
            readonly
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="m-0">
      <b-col lg="4">
        <b-form-group
          :label="$t('reporting_channel.status')"
          label-for="status"
        >
          <b-form-input
            id="status"
            :value="_.get(requestForm, 'status_str')"
            readonly
          />
        </b-form-group>
      </b-col>
      <b-col lg="8" class="print:hidden" v-if="showHistory">
        <HandlingHistoryPopup :id="id" :serviceDelegate="services.handling" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Datepicker from 'educatena-vuejs-datepicker'
import vSelect from 'vue-select'
import NavigationOriginPopup from '@/components/popup/NavigationOriginPopup'
import ProtocolQueryHistoryPopup from '@/components/popup/ProtocolQueryHistoryPopup'
import HandlingHistoryPopup from '@/components/popup/HandlingHistoryPopup'

import MediaList from '@/components/media/MediaList.vue'

import {
  BContainer,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormTextarea,
  BCard,
  BTable,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip
} from 'bootstrap-vue'

//Services
import ReportingChannelFormHandlingService from '@/services/api/reporting-channel/ReportingChannelFormHandlingService'

export default {
  directives: {
    'b-tooltip': VBTooltip
  },
  components: {
    Datepicker,
    vSelect,
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BTable,
    NavigationOriginPopup,
    ProtocolQueryHistoryPopup,
    HandlingHistoryPopup,
    MediaList
  },
  props: {
    id: {
      //Id handling
      type: Number,
      default: null
    },
    requestForm: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    showHistory: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    id: null,
    services: {
      handling: null
    }
  }),
  methods: {
    configClassTextField(value) {
      return value ? 'h-full' : 'min-h-full'
    }
  },
  watch: {},
  computed: {
    customerRelationship() {
      const id = this._.get(
        this.requestForm,
        'form.data.form_data.customerRelationship.id'
      )
      const name = this._.get(
        this.requestForm,
        'form.data.form_data.customerRelationship.name'
      )
      const other = this._.get(
        this.requestForm,
        'form.data.form_data.customerRelationshipOther'
      )
      return id && parseInt(id) === 100 ? other : name
    },
    typeReporting() {
      const id = this._.get(
        this.requestForm,
        'form.data.form_data.typeReporting.id'
      )
      const name = this._.get(
        this.requestForm,
        'form.data.form_data.typeReporting.name'
      )
      const other = this._.get(
        this.requestForm,
        'form.data.form_data.typeReportingOther'
      )
      return id && parseInt(id) === 100 ? other : name
    },
    knowFact() {
      const id = this._.get(this.requestForm, 'form.data.form_data.knowFact.id')
      const name = this._.get(
        this.requestForm,
        'form.data.form_data.knowFact.name'
      )
      const other = this._.get(
        this.requestForm,
        'form.data.form_data.knowFactOther'
      )
      return id && parseInt(id) === 100 ? other : name
    },
    navigationField() {
      return this._.get(
        this.requestForm,
        'form.navigation_origin.metadata.navigationUser'
      )
    },
    isIdentify() {
      return this._.get(
        this.requestForm,
        'form.data.form_data.isIdentify',
        false
      )
    },
    files() {
      return this._.get(this.requestForm, 'form.media', [])
    },
    severityLevelDisplay() {
      const severityLevel = this._.get(this.requestForm, 'severity_level')
      if (severityLevel && severityLevel.label) {
        return severityLevel.label
      }
      return 'Não classificado'
    }
  },
  mounted() {
    //Services
    const promisses = []
  },
  beforeMount() {
    //Services
    this.services.handling = ReportingChannelFormHandlingService.build(this.$vs)
  }
}
</script>
